import {
  ActionName,
  ActionProcessMode,
  CategoryName,
} from '@infotech-soe/metaschema';

import { CommandName } from '../CommandViewModel';
import { UserInteractor, UserInteractorType } from '../UserInteractor';

import CategoryCommandImpl from './CategoryCommandImpl';

class ReviewRecordCommandImpl extends CategoryCommandImpl<unknown> {
  constructor(
    protected category: CategoryName,
    protected action: ActionName
  ) {
    super();
  }

  public async execute(): Promise<void> {
    // not implemented
  }

  public getUserInteractor(): UserInteractor {
    return {
      type: UserInteractorType.REVIEW_FORM,
      category: this.category,
      action: this.action,
    };
  }

  public getName(): CommandName {
    return 'review';
  }

  public getProcessMode(): ActionProcessMode {
    return 'Current';
  }

  public async getInitialArgs(): Promise<void> {
    return;
  }
}

export default ReviewRecordCommandImpl;
